import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import { _ } from '_locales';
import { colors } from '_styles';

import {
  googleCalendarUrl, iCalUrl, otherCalUrl, outlookUrl
} from '_apis';
import { eventTracker } from '_helpers';
import { alert as alertSetup } from '_actions';

// eslint-disable-next-line import/no-cycle
import { OutlookExportModal } from '.';

// style
const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const ExportButton = styled.button`
    color: #FFFFFF;
    border: none;
    font-size: 14px !important;
     
    height: auto;
    text-shadow: #000000 0px 0px 1px;
    border-radius: 5px;
    padding: 10px 20px;
    box-sizing: border-box;
    max-width: 160px;
    background: ${(props) => props.secondaryColor};
    position: relative;
    cursor: pointer;
    flex: 1;
    text-transform: capitalize;

    ${(parentWidth < 431) && css`
      display: block;
      margin-top: 10px;
      width: 160px;
      padding: 14px 20px;
    `};
`;

const ConfirmToExport = ({
  colStr,
  calType,
  colObject,
  projectId,
  modalConfirmAction,
  districtId,
  setModalConfirmAction,
  setModalType,
  setIsModalOpen,
  setModalAlertingMessage,
  zoneStr,
  setModalConfirmActionCallback,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const calendarType = {
    iCal: `${iCalUrl}calendar/export/${projectId}/${districtId}/${zoneStr}.ics`,
    OutLook: `${outlookUrl}`,
    Google_Calendar: `${googleCalendarUrl}calendar/export/${projectId}/${districtId}/${zoneStr}.ics`,
    Other: `${otherCalUrl}calendar/export/${projectId}/${districtId}/${zoneStr}.ics`,
  };

  const triggerAlertIt = (text, isQuestion) => {
    setModalAlertingMessage(text);
    setModalConfirmActionCallback(() => openCalendar());
    setIsModalOpen(true);
    if (isQuestion) {
      setModalType('question');
    }
  };

  useEffect(() => {
    if (modalConfirmAction) {
      setModalConfirmAction(false);
    }
  }, [modalConfirmAction]);

  const openCalendar = () => {
    window.open(calendarType[calType], '_blank');
  };

  const validation = () => {
    eventTracker('Export Calendar', colStr);
    if (calType === '') {
      return triggerAlertIt(_('cal.please_select_a_calendar_to_export'));
    }

    if (calType === 'Google_Calendar') {
      triggerAlertIt(_('cal.calendar_data_is_ready_to_be_exported'), true);
    } else if (calType === 'OutLook') {
      openModal();
    } else {
      window.open(calendarType[calType], '_blank');
    }
    return false;
  };

  const openModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      {isModalVisible && (
        <OutlookExportModal calendarType={calendarType} handleClose={closeModal} />
      )}
      <ExportButton
        onClick={() => validation()}
        secondaryColor={colors.RC_ACTION}
        aria-label="confirm to export the calendar"
      >
        {_('cal.export_calendar')}
      </ExportButton>
    </>
  );
};

const mapStateToProps = (state) => ({
  modalConfirmAction: state.alert.modalConfirmAction,
  selectedLang: state.config.selectedLang,
});

const mapDispatchToProps = (dispatch) => ({
  setModalConfirmAction: (modalConfirmAction) => dispatch(
    alertSetup.setModalConfirmAction(modalConfirmAction)
  ),
  setModalType: (modalType) => dispatch(alertSetup.setModalType(modalType)),
  setIsModalOpen: (isModalOpen) => dispatch(alertSetup.setIsModalOpen(isModalOpen)),
  setModalAlertingMessage: (modalAlertingMessage) => dispatch(
    alertSetup.setModalAlertingMessage(modalAlertingMessage)
  ),
  setModalConfirmActionCallback: (modalConfirmActionCallback) => dispatch(
    alertSetup.setModalConfirmActionCallback(modalConfirmActionCallback)
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmToExport);
